import { Button, Icon } from '@zoom/components';
import { FormApi } from 'final-form';
import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'reactstrap';

import { finalFormNumberInputHelper } from '../../components/Inputs/RenderNumberInput';
import { RangeFilter } from '../../types';
import { inRange } from '../../utils/validations/inRange';
import { ADHERENCE_HISTORY_RANGE_FILTERS_CONSTRAINS } from './config';
import { getFilterInputResetTag, getFilterInputTag } from './constants';
import { AdherenceHistorySidebarFilterState, SidebarRangeFilterTile } from './types';

interface AdherenceHistoryRangeFilterTileProps {
  filter: SidebarRangeFilterTile;
  form: FormApi<AdherenceHistorySidebarFilterState>;
}

export const defaultRangeFilter: RangeFilter = {
  min: undefined,
  max: undefined,
};

export const AdherenceHistoryRangeFilterTile: React.FC<AdherenceHistoryRangeFilterTileProps> = ({ filter, form }) => {
  const { t } = useTranslation();

  const { key } = filter;

  const minName = `${key}.min`;
  const maxName = `${key}.max`;

  const values = form.getState().values[key];

  const handleReset = () => {
    form.change(key, defaultRangeFilter);
  };

  return (
    <>
      <Row className="range-filter-tile__wrapper">
        <Col>
          <Field
            key={`${minName}-${values?.max}`}
            name={minName}
            validate={inRange(
              ADHERENCE_HISTORY_RANGE_FILTERS_CONSTRAINS[key].min,
              ADHERENCE_HISTORY_RANGE_FILTERS_CONSTRAINS[key].max
            )}
            render={finalFormNumberInputHelper({
              dataTestId: getFilterInputTag(minName, filter.filterInputType),
              label: `${t('filter.min')} ${filter.isPercentage ? ' %' : ''}`,
              max: ADHERENCE_HISTORY_RANGE_FILTERS_CONSTRAINS[key].max,
              min: ADHERENCE_HISTORY_RANGE_FILTERS_CONSTRAINS[key].min,
              noValidation: false,
              toCentre: false,
              type: 'number',
            })}
          />
        </Col>
        <Col>
          <Field
            key={`${maxName}-${values?.min}`}
            name={maxName}
            validate={inRange(
              values?.min || ADHERENCE_HISTORY_RANGE_FILTERS_CONSTRAINS[key].min,
              ADHERENCE_HISTORY_RANGE_FILTERS_CONSTRAINS[key].max
            )}
            render={finalFormNumberInputHelper({
              dataTestId: getFilterInputTag(maxName, filter.filterInputType),
              label: `${t('filter.max')} ${filter.isPercentage ? ' %' : ''}`,
              max: ADHERENCE_HISTORY_RANGE_FILTERS_CONSTRAINS[key].max,
              min: ADHERENCE_HISTORY_RANGE_FILTERS_CONSTRAINS[key].min,
              noValidation: false,
              toCentre: false,
              type: 'number',
            })}
          />
        </Col>
      </Row>
      {typeof (values?.max || values?.min) === 'number' && (
        <div className="range-filter-tile__reset">
          <Button
            className="p-2"
            data-test-id={getFilterInputResetTag(key, filter.filterInputType)}
            kind="icon"
            onClick={handleReset}
          >
            <Icon kind="cross" size={15} color="grey3" className="mr-2" />
            {t('filter.reset')}
          </Button>
        </div>
      )}
    </>
  );
};
